<div class="qb-parent-container-selection qb-h-100" id="form-container">
  <div class="qb-header-container">
    <div class="qb-header-text-challenge">Challenge Details</div>
    <div class="qb-description-challenge">
      This page captures user-provided details like name, description, rules,
      deadlines, and rewards for a challenge.
    </div>
  </div>
  <div class="qb-selection-part">
    <div class="qb-selection-wrapper">
      <form [formGroup]="dataForm">
        <div>
          <span class="main-label-style">
            {{ "SHARED_PAGE.CHALLENGE_NAME" | i18nTranslate }}
          </span>
          <span style="color: #c71a1a; font-size: 12px">*</span>

          <div style="margin-top: 5px; margin-bottom: 10px">
            <div class="pos-rel">
              <ngx-editor
                [editor]="nameEditor"
                (paste)="onPaste($event)"
                formControlName="name"
                (keydown)="stringInputHandler($event, 50, 'name')"
                [ngClass]="{
                  error:
                    dataForm.get('name')?.errors &&
                    (dataForm.get('name')?.touched || submitClicked)
                }"
              ></ngx-editor>
              <ngx-editor-menu [editor]="nameEditor" [toolbar]="toolbar">
              </ngx-editor-menu>
              <div class="remaining-text-left-new">
                {{ getCountOfText(dataForm.get("name")?.value) || 0 }}/50
              </div>
            </div>

            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="name-error"
            >
            </span>
            <span
              *ngIf="duplicateNameErrorText.length > 0"
              style="color: var(--main-font-red); font-size: 12px"
              >{{ duplicateNameErrorText }}</span
            >
          </div>
        </div>

        <div>
          <span class="main-label-style">
            Alias {{ "SHARED_PAGE.CHALLENGE_NAME" | i18nTranslate }}
          </span>

          <div style="margin-top: 5px; margin-bottom: 10px">
            <div class="pos-rel">
              <!-- NgxEditor Component -->
              <ngx-editor
                [editor]="aliasNameEditor"
                (paste)="onPaste($event)"
                formControlName="aliasName"
                (keydown)="stringInputHandler($event, 50, 'aliasName')"
                [ngClass]="{
                  error:
                    dataForm.get('aliasName')?.errors &&
                    (dataForm.get('aliasName')?.touched || submitClicked)
                }"
              ></ngx-editor>
              <ngx-editor-menu [editor]="aliasNameEditor" [toolbar]="toolbar">
              </ngx-editor-menu>
              <div class="remaining-text-left-new">
                {{ getCountOfText(dataForm.get("aliasName")?.value) || 0 }}/50
              </div>
            </div>

            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="aliasName-error"
            >
            </span>
          </div>
        </div>

        <div>
          <span class="main-label-style"> Challenge Heading </span>

          <div style="margin-top: 5px; margin-bottom: 10px">
            <div class="pos-rel challenge-heading">
              <!-- NgxEditor Component -->
              <ngx-editor
                class="custom-editor"
                [editor]="headerEditor"
                (paste)="onPaste($event)"
                formControlName="header"
                (keydown)="stringInputHandler($event, 50, 'header')"
                [ngClass]="{
                  error:
                    dataForm.get('header')?.errors &&
                    (dataForm.get('header')?.touched || submitClicked)
                }"
              ></ngx-editor>
              <ngx-editor-menu [editor]="headerEditor" [toolbar]="toolbar">
              </ngx-editor-menu>
              <div class="remaining-text-left-new">
                {{ getCountOfText(dataForm.get("header")?.value) || 0 }}/50
              </div>
            </div>

            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="header-error"
            >
            </span>
          </div>
        </div>

        <div>
          <span class="main-label-style">
            {{ "SHARED_PAGE.CHALLENGE_DESCRIPTION" | i18nTranslate }}
          </span>

          <div style="margin-top: 5px; margin-bottom: 10px">
            <div class="pos-rel">
              <!-- NgxEditor Component -->
              <ngx-editor
                [editor]="descriptionEditor"
                (paste)="onPaste($event)"
                formControlName="description"
                (keydown)="stringInputHandler($event, 300, 'description')"
                [ngClass]="{
                  error:
                    dataForm.get('description')?.errors &&
                    (dataForm.get('description')?.touched || submitClicked)
                }"
              ></ngx-editor>
              <ngx-editor-menu [editor]="descriptionEditor" [toolbar]="toolbar">
              </ngx-editor-menu>
              <div class="remaining-text-left-new">
                {{
                  getCountOfText(dataForm.get("description")?.value) || 0
                }}/300
              </div>
            </div>

            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="description-error"
            >
            </span>
          </div>
        </div>

        <div>
          <span class="main-label-style">
            Alias {{ "SHARED_PAGE.CHALLENGE_DESCRIPTION" | i18nTranslate }}
          </span>

          <div style="margin-top: 5px; margin-bottom: 10px">
            <div class="pos-rel">
              <!-- NgxEditor Component -->
              <ngx-editor
                [editor]="aliasDescriptionEditor"
                (paste)="onPaste($event)"
                formControlName="aliasDescription"
                (keydown)="stringInputHandler($event, 300, 'aliasDescription')"
                [ngClass]="{
                  error:
                    dataForm.get('aliasDescription')?.errors &&
                    (dataForm.get('aliasDescription')?.touched || submitClicked)
                }"
              ></ngx-editor>
              <ngx-editor-menu
                [editor]="aliasDescriptionEditor"
                [toolbar]="toolbar"
              >
              </ngx-editor-menu>
              <div class="remaining-text-left-new">
                {{
                  getCountOfText(dataForm.get("aliasDescription")?.value) || 0
                }}/300
              </div>
            </div>

            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="aliasDescription-error"
            >
            </span>
          </div>
        </div>
      </form>

      <div [ngClass]="{ 'cursor-notallowed': status == 'ACTIVE' }">
        <div [ngClass]="{ 'pointerevents-none': status == 'ACTIVE' }">
          <div>
            <span class="main-label-style">{{
              "SHARED_PAGE.CHOOSE_SEGMENT_CHALLENGE" | i18nTranslate
            }}</span>
            <span style="color: var(--main-font-red); font-size: 12px">*</span>
          </div>
          <div>
            <div class="flex-with-gap">
              <div
                class="multi-select-panel-challenge"
                id="multi-select-panel-challenge"
                (click)="toggleSelect($event, 'include')"
              >
                <span class="color-black"
                  >{{ "SHARED_PAGE.SELECTED" | i18nTranslate }}
                  {{ customerSegments.length }}</span
                >
                <div
                  class="keyboard-down-icon-container"
                  id="keyboard-down-icon-container"
                >
                  <mat-icon class="keyboard-down-icon"
                    >keyboard_arrow_down</mat-icon
                  >
                </div>
              </div>
              <app-segmentation-customer-list-redirect
                [miniVer]="true"
              ></app-segmentation-customer-list-redirect>
            </div>

            <div style="position: relative">
              <div
                class="multi-select-dropdown-challenges"
                id="multi-select-dropdown"
              >
                <div class="search">
                  <input
                    [(ngModel)]="segmentFilter"
                    placeholder="Search"
                    type="text"
                    style="border: none; outline: none; width: 100%"
                  />
                  <span
                    class="material-icons-outlined"
                    *ngIf="segmentFilter.length == 0"
                  >
                    search
                  </span>
                  <span
                    class="material-icons-outlined icons-primary cursor-pointer"
                    style="font-size: 19px"
                    *ngIf="segmentFilter.length > 0"
                    (click)="segmentFilter = ''"
                  >
                    close
                  </span>
                </div>
                <div class="border-line"></div>
                <div id="segment-select" class="segment-select">
                  <div>
                    <div>
                      <mat-checkbox
                        class="custom-check"
                        *ngFor="
                          let segment of allcustomerObj
                            | labelPipe : segmentFilter : 'segmentName'
                        "
                        [checked]="customerSegments.includes(segment.id)"
                        (change)="addAllCustomers($event, segment.id)"
                        color="primary"
                      >
                        <span>
                          {{ segment.segmentName | limitTo : 40 }}
                        </span>
                      </mat-checkbox>
                    </div>

                    <div
                      class="category-text-container"
                      *ngIf="isSegmentPresent()"
                    >
                      <div class="category-line"></div>
                      <span class="category-text">{{
                        "SHARED_PAGE.SEGMENTS" | i18nTranslate
                      }}</span>
                      <div class="category-line"></div>
                    </div>

                    <div
                      class="qb-admin-store-lists"
                      *ngIf="isStoreSegmentsPresent()"
                    >
                      <span class="category-text">{{
                        storeId == null
                          ? "Admin Created Segments"
                          : "Store Created Segments"
                      }}</span>
                    </div>

                    <div *ngIf="isStoreSegmentsPresent()">
                      <div
                        *ngFor="
                          let segment of data.segments
                            | labelPipe : segmentFilter : 'segmentName'
                        "
                      >
                        <ng-container
                          *ngIf="
                            segment.category.toLowerCase() === 'segment' &&
                            isStoreCreated(segment)
                          "
                        >
                          <mat-checkbox
                            class="custom-check"
                            [checked]="isIncluded(segment, 'segment')"
                            (change)="updateCheckboxValues(segment, 'segment')"
                            [disabled]="!segment['isActive']"
                            color="primary"
                          >
                            <span
                              [matTooltip]="
                                segment['isActive']
                                  ? segment.segmentName
                                  : 'We are preparing your segment. It will be available for use shortly'
                              "
                              >{{ segment.segmentName }}</span
                            >
                          </mat-checkbox>
                        </ng-container>
                      </div>
                    </div>

                    <div
                      class="qb-admin-store-lists"
                      *ngIf="isOtherSegmentsPresent()"
                    >
                      <span class="category-text">Other Segments</span>
                    </div>

                    <div *ngIf="isOtherSegmentsPresent()">
                      <div
                        *ngFor="
                          let segment of data.segments
                            | labelPipe : segmentFilter : 'segmentName'
                        "
                      >
                        <ng-container
                          *ngIf="
                            segment.category.toLowerCase() === 'segment' &&
                            !isStoreCreated(segment)
                          "
                        >
                          <mat-checkbox
                            class="custom-check"
                            [checked]="isIncluded(segment, 'segment')"
                            (change)="updateCheckboxValues(segment, 'segment')"
                            [disabled]="!segment['isActive']"
                            color="primary"
                          >
                            <span
                              [matTooltip]="
                                segment['isActive']
                                  ? segment.segmentName
                                  : 'We are preparing your segment. It will be available for use shortly'
                              "
                              >{{ segment.segmentName }}</span
                            >
                          </mat-checkbox>
                        </ng-container>
                      </div>
                    </div>
                    <div
                      class="category-text-container"
                      *ngIf="isTierSegmentPresent()"
                    >
                      <div class="category-line"></div>
                      <span class="category-text">{{
                        "SHARED_PAGE.LOYALITY_TIERS" | i18nTranslate
                      }}</span>
                      <div class="category-line"></div>
                    </div>
                    <div
                      *ngFor="
                        let segment of data.segments
                          | labelPipe : segmentFilter : 'segmentName'
                      "
                    >
                      <ng-container
                        *ngIf="segment.category.toLowerCase() == 'tier'"
                      >
                        <!-- [checked]="customerSegments | isChecked: segment.id" -->
                        <mat-checkbox
                          class="custom-check"
                          [checked]="isIncluded(segment, 'tier')"
                          (change)="updateCheckboxValues(segment, 'tier')"
                          [disabled]="!segment['isActive']"
                          color="primary"
                          ><span
                            [matTooltip]="
                              segment['isActive']
                                ? segment.segmentName
                                : 'We are preparing your segment. It will be available for use shortly'
                            "
                            [matTooltipPosition]="'right'"
                          >
                            {{ segment.segmentName | limitTo : 40 }}
                          </span>
                        </mat-checkbox>
                      </ng-container>
                    </div>
                    <div
                      class="category-text-container"
                      *ngIf="isCustomerListPresent()"
                    >
                      <div class="category-line"></div>
                      <span class="category-text">{{
                        "COMMON_PAGE.CUSTOMER_LIST" | i18nTranslate
                      }}</span>
                      <div class="category-line"></div>
                    </div>

                    <div
                      *ngIf="isStoreCustomerListPresent()"
                      class="qb-admin-store-lists"
                    >
                      <span class="category-text">{{
                        storeId === null
                          ? "Admin Created Custom List"
                          : "Store Created Custom List"
                      }}</span>
                    </div>
                    <div
                      *ngFor="
                        let segment of data.segments
                          | labelPipe : segmentFilter : 'segmentName'
                      "
                    >
                      <ng-container
                        *ngIf="
                          segment.category.toLowerCase() === 'customerlist' &&
                          isStoreCreated(segment)
                        "
                      >
                        <mat-checkbox
                          class="custom-check"
                          [checked]="isIncluded(segment, 'customerlist')"
                          (change)="
                            updateCheckboxValues(segment, 'customerlist')
                          "
                          [disabled]="!segment['isActive']"
                          color="primary"
                        >
                          <span
                            [matTooltip]="
                              segment['isActive']
                                ? segment.segmentName
                                : 'We are preparing your custom list. It will be available for use shortly'
                            "
                            [matTooltipPosition]="'right'"
                          >
                            {{ segment.segmentName | limitTo : 40 }}
                          </span>
                        </mat-checkbox>
                      </ng-container>
                    </div>
                    <div
                      *ngIf="isOtherCustomerListPresent()"
                      class="qb-admin-store-lists"
                    >
                      <span class="category-text">Other Custom List</span>
                    </div>
                    <div
                      *ngFor="
                        let segment of data.segments
                          | labelPipe : segmentFilter : 'segmentName'
                      "
                    >
                      <ng-container
                        *ngIf="
                          segment.category.toLowerCase() === 'customerlist' &&
                          !isStoreCreated(segment)
                        "
                      >
                        <mat-checkbox
                          class="custom-check"
                          [checked]="isIncluded(segment, 'customerlist')"
                          (change)="
                            updateCheckboxValues(segment, 'customerlist')
                          "
                          [disabled]="!segment['isActive']"
                          color="primary"
                        >
                          <span
                            [matTooltip]="
                              segment['isActive']
                                ? segment.segmentName
                                : 'We are preparing your custom list. It will be available for use shortly'
                            "
                            [matTooltipPosition]="'right'"
                          >
                            {{ segment.segmentName | limitTo : 40 }}
                          </span>
                        </mat-checkbox>
                      </ng-container>
                    </div>
                    <div
                      class="category-text-container"
                      *ngIf="isEmployeeListPresent()"
                    >
                      <div class="category-line"></div>
                      <span class="category-text">{{
                        "COMMON_PAGE.EMPLOYEE_LIST" | i18nTranslate
                      }}</span>
                      <div class="category-line"></div>
                    </div>
                    <div
                      *ngFor="
                        let segment of data.segments
                          | labelPipe : segmentFilter : 'segmentName'
                      "
                    >
                      <ng-container
                        *ngIf="segment.category.toLowerCase() == 'employeelist'"
                      >
                        <!-- [checked]="customerSegments | isChecked: segment.id" -->
                        <mat-checkbox
                          class="custom-check"
                          [checked]="isIncluded(segment, 'employeelist')"
                          (change)="
                            updateCheckboxValues(segment, 'employeelist')
                          "
                          [disabled]="!segment['isActive']"
                          [matTooltip]="
                            data.customerSegmentSelect
                              ? segment['isActive']
                                ? segment.segmentName
                                : 'We are preparing your Employee list. It will be available for use shortly'
                              : 'Sign up event is applicable to All customers only'
                          "
                          color="primary"
                          [matTooltipPosition]="'right'"
                          ><span
                            [matTooltip]="
                              data.customerSegmentSelect
                                ? segment['isActive']
                                  ? segment.segmentName
                                  : 'We are preparing your Employee list. It will be available for use shortly'
                                : 'Sign up event is applicable to All customers only'
                            "
                            color="primary"
                            [matTooltipPosition]="'right'"
                          >
                            {{ segment.segmentName | limitTo : 40 }}
                          </span></mat-checkbox
                        >
                      </ng-container>
                    </div>
                    <div
                      *ngIf="
                        !isSegmentPresent() &&
                        !isTierSegmentPresent() &&
                        !isCustomerListPresent() &&
                        !isEmployeeListPresent()
                      "
                      class="no-data"
                    >
                      {{ "SHARED_PAGE.NO_DATA_AVAILABLE" | i18nTranslate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="left-align-text-err qb-w-50">
            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="errorField"
            ></span>
          </div>

          <!-- Exclusion of segments -->
<!-- 
          <div>
            <span class="main-label-style">{{
              "SHARED_PAGE.CHOOSE_EXCLUSION_SEGMENT_CHALLENGE" | i18nTranslate
            }}</span>
          </div> -->

          <!-- <div>
            <div class="flex-with-gap">
              <div
                class="exclude-select-panel-challenge"
                id="exclude-select-panel-challenge"
                (click)="toggleSelect($event, 'exclude')"
              >
                <span class="color-black"
                  >{{ "SHARED_PAGE.SELECTED" | i18nTranslate }}
                  {{ excludedSegments.length }}</span
                >
                <div
                  class="keyboard-down-icon-container"
                  id="keyboard-down-icon-container-2"
                >
                  <mat-icon class="keyboard-down-icon"
                    >keyboard_arrow_down</mat-icon
                  >
                </div>
              </div>
            </div>

            <div style="position: relative">
              <div
                class="multi-select-dropdown-challenges"
                id="exclude-select-dropdown"
              >
                <div class="search">
                  <input
                    [(ngModel)]="excludeSegmentFilter"
                    placeholder="Search"
                    type="text"
                    style="border: none; outline: none; width: 100%"
                  />
                  <span
                    class="material-icons-outlined"
                    *ngIf="excludeSegmentFilter.length == 0"
                  >
                    search
                  </span>
                  <span
                    class="material-icons-outlined icons-primary cursor-pointer"
                    style="font-size: 19px"
                    *ngIf="segmentFilter.length > 0"
                    (click)="segmentFilter = ''"
                  >
                    close
                  </span>
                </div>
                <div class="border-line"></div>
                <div id="exclude-select" class="exclude-select">
                  <div>
                    <div
                      class="category-text-container"
                      *ngIf="isSegmentPresent2()"
                    >
                      <div class="category-line"></div>
                      <span class="category-text">{{
                        "SHARED_PAGE.SEGMENTS" | i18nTranslate
                      }}</span>
                      <div class="category-line"></div>
                    </div>

                    <div
                      class="qb-admin-store-lists"
                      *ngIf="isStoreSegmentsPresent2()"
                    >
                      <span class="category-text">{{
                        storeId == null
                          ? "Admin Created Segments"
                          : "Store Created Segments"
                      }}</span>
                    </div>

                    <div *ngIf="isStoreSegmentsPresent()">
                      <div
                        *ngFor="
                          let segment of data.segments
                            | labelPipe : excludeSegmentFilter : 'segmentName'
                        "
                      >
                        <ng-container
                          *ngIf="
                            segment.category.toLowerCase() === 'segment' &&
                            isStoreCreated(segment)
                          "
                        >
                          <mat-checkbox
                            class="custom-check"
                            [checked]="isExcluded(segment, 'segment')"
                            (change)="excludeSegment(segment, 'segment')"
                            [disabled]="!segment['isActive']"
                            color="primary"
                          >
                            <span
                              [matTooltip]="
                                data.customerSegmentSelect
                                  ? segment['isActive']
                                    ? segment.segmentName
                                    : 'We are preparing your segment. It will be available for use shortly'
                                  : 'Sign up event is applicable to All customers only'
                              "
                              >{{ segment.segmentName }}</span
                            >
                          </mat-checkbox>
                        </ng-container>
                      </div>
                    </div>

                    <div
                      class="qb-admin-store-lists"
                      *ngIf="isOtherSegmentsPresent2()"
                    >
                      <span class="category-text">Other Segments</span>
                    </div>

                    <div *ngIf="isOtherSegmentsPresent2()">
                      <div
                        *ngFor="
                          let segment of data.segments
                            | labelPipe : excludeSegmentFilter : 'segmentName'
                        "
                      >
                        <ng-container
                          *ngIf="
                            segment.category.toLowerCase() === 'segment' &&
                            !isStoreCreated(segment)
                          "
                        >
                          <mat-checkbox
                            class="custom-check"
                            [checked]="isExcluded(segment, 'segment')"
                            (change)="excludeSegment(segment, 'segment')"
                            [disabled]="!segment['isActive']"
                            color="primary"
                          >
                            <span
                              [matTooltip]="
                                data.customerSegmentSelect
                                  ? segment['isActive']
                                    ? segment.segmentName
                                    : 'We are preparing your segment. It will be available for use shortly'
                                  : 'Sign up event is applicable to All customers only'
                              "
                              >{{ segment.segmentName }}</span
                            >
                          </mat-checkbox>
                        </ng-container>
                      </div>
                    </div>

                    <div
                      class="category-text-container"
                      *ngIf="isTierSegmentPresent2()"
                    >
                      <div class="category-line"></div>
                      <span class="category-text">{{
                        "SHARED_PAGE.LOYALITY_TIERS" | i18nTranslate
                      }}</span>
                      <div class="category-line"></div>
                    </div>
                    <div
                      *ngFor="
                        let segment of data.segments
                          | labelPipe : excludeSegmentFilter : 'segmentName'
                      "
                    >
                      <ng-container
                        *ngIf="segment.category.toLowerCase() == 'tier'"
                      >
                        <mat-checkbox
                          class="custom-check"
                          [checked]="isExcluded(segment, 'tier')"
                          (change)="excludeSegment(segment, 'tier')"
                          [disabled]="!segment['isActive']"
                          color="primary"
                          ><span
                            [matTooltip]="
                              data.customerSegmentSelect
                                ? segment['isActive']
                                  ? segment.segmentName
                                  : 'We are preparing your segment. It will be available for use shortly'
                                : 'Sign up event is applicable to All customers only'
                            "
                            [matTooltipPosition]="'right'"
                          >
                            {{ segment.segmentName | limitTo : 40 }}
                          </span>
                        </mat-checkbox>
                      </ng-container>
                    </div>

                    <div
                      class="category-text-container"
                      *ngIf="isCustomerListPresent2()"
                    >
                      <div class="category-line"></div>
                      <span class="category-text">{{
                        "COMMON_PAGE.CUSTOMER_LIST" | i18nTranslate
                      }}</span>
                      <div class="category-line"></div>
                    </div>

                    <div
                      *ngIf="isStoreCustomerListPresent2()"
                      class="qb-admin-store-lists"
                    >
                      <span class="category-text">{{
                        storeId === null
                          ? "Admin Created Custom List"
                          : "Store Created Custom List"
                      }}</span>
                    </div>
                    <div
                      *ngFor="
                        let segment of data.segments
                          | labelPipe : excludeSegmentFilter : 'segmentName'
                      "
                    >
                      <ng-container
                        *ngIf="
                          segment.category.toLowerCase() === 'customerlist' &&
                          isStoreCreated(segment)
                        "
                      >
                        <mat-checkbox
                          class="custom-check"
                          [checked]="isExcluded(segment, 'customerlist')"
                          (change)="excludeSegment(segment, 'customerlist')"
                          [disabled]="!segment['isActive']"
                          color="primary"
                        >
                          <span
                            [matTooltip]="
                              segment['isActive']
                                ? segment.segmentName
                                : 'We are preparing your custom list. It will be available for use shortly'
                            "
                            [matTooltipPosition]="'right'"
                          >
                            {{ segment.segmentName | limitTo : 40 }}
                          </span>
                        </mat-checkbox>
                      </ng-container>
                    </div>

                    <div
                      *ngIf="isOtherCustomerListPresent2()"
                      class="qb-admin-store-lists"
                    >
                      <span class="category-text">Other Custom List</span>
                    </div>
                    <div
                      *ngFor="
                        let segment of data.segments
                          | labelPipe : excludeSegmentFilter : 'segmentName'
                      "
                    >
                      <ng-container
                        *ngIf="
                          segment.category.toLowerCase() === 'customerlist' &&
                          !isStoreCreated(segment)
                        "
                      >
                        <mat-checkbox
                          class="custom-check"
                          [checked]="isExcluded(segment, 'customerlist')"
                          (change)="excludeSegment(segment, 'customerlist')"
                          [disabled]="!segment['isActive']"
                          color="primary"
                        >
                          <span
                            [matTooltip]="
                              segment['isActive']
                                ? segment.segmentName
                                : 'We are preparing your custom list. It will be available for use shortly'
                            "
                            [matTooltipPosition]="'right'"
                          >
                            {{ segment.segmentName | limitTo : 40 }}
                          </span>
                        </mat-checkbox>
                      </ng-container>
                    </div>

                    <div
                      class="category-text-container"
                      *ngIf="isEmployeeListPresent2()"
                    >
                      <div class="category-line"></div>
                      <span class="category-text">{{
                        "COMMON_PAGE.EMPLOYEE_LIST" | i18nTranslate
                      }}</span>
                      <div class="category-line"></div>
                    </div>
                    <div
                      *ngFor="
                        let segment of data.segments
                          | labelPipe : excludeSegmentFilter : 'segmentName'
                      "
                    >
                      <ng-container
                        *ngIf="segment.category.toLowerCase() == 'employeelist'"
                      >
                        <mat-checkbox
                          class="custom-check"
                          [checked]="isExcluded(segment, 'employeelist')"
                          (change)="excludeSegment(segment, 'employeelist')"
                          [disabled]="!segment['isActive']"
                          [matTooltip]="
                            data.customerSegmentSelect
                              ? segment['isActive']
                                ? segment.segmentName
                                : 'We are preparing your Employee list. It will be available for use shortly'
                              : 'Sign up event is applicable to All customers only'
                          "
                          color="primary"
                          [matTooltipPosition]="'right'"
                          ><span
                            [matTooltip]="
                              data.customerSegmentSelect
                                ? segment['isActive']
                                  ? segment.segmentName
                                  : 'We are preparing your Employee list. It will be available for use shortly'
                                : 'Sign up event is applicable to All customers only'
                            "
                            color="primary"
                            [matTooltipPosition]="'right'"
                          >
                            {{ segment.segmentName | limitTo : 40 }}
                          </span></mat-checkbox
                        >
                      </ng-container>
                    </div>
                    <div
                      *ngIf="
                        !isSegmentPresent2() &&
                        !isTierSegmentPresent2() &&
                        !isCustomerListPresent2() &&
                        !isEmployeeListPresent2()
                      "
                      class="no-data"
                    >
                      {{ "SHARED_PAGE.NO_DATA_AVAILABLE" | i18nTranslate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <div class="count-details-challenges">
        <div class="box row g-0">
          <div class="col-4 box-icon-container">
            <div class="material-symbols-outlined box-icon">group</div>
          </div>
          <div class="col-8 flex-col" *ngIf="isAdmin">
            <div class="main-label-style flex-1" id="definition">
              {{ "SHARED_PAGE.CUSTOMER_TARGETED" | i18nTranslate }}
            </div>
            <div class="details">
              <app-qubriux-loading
                *ngIf="totalCustomerCount === null"
                [size]="15"
              ></app-qubriux-loading>
              <div id="count" *ngIf="totalCustomerCount !== null">
                {{ totalCustomerCount }}
              </div>
            </div>
          </div>

          <div class="col-8 flex-col" *ngIf="!isAdmin">
            <div class="main-label-style flex-1" id="definition">
              {{ "SHARED_PAGE.STORE_CUSTOMER_TARGETED" | i18nTranslate }} /
              {{ "SHARED_PAGE.CUSTOMER_TARGETED" | i18nTranslate }}
            </div>
            <div class="details">
              <app-qubriux-loading
                *ngIf="totalCustomerCount === null"
                [size]="15"
              ></app-qubriux-loading>
              <div id="count" *ngIf="totalCustomerCount !== null">
                {{ storeTargetedCustomerCount }} / {{ totalCustomerCount }}
              </div>
            </div>
          </div>
        </div>

        <div class="box row g-0">
          <div class="col-4 box-icon-container">
            <div class="material-symbols-outlined box-icon">mail</div>
          </div>
          <div class="col-8 flex-col">
            <div class="main-label-style flex-1" id="definition">
              {{ "SHARED_PAGE.CUSTOMER_HAVING_VALID_EMAIL" | i18nTranslate }}
            </div>
            <div class="details">
              <app-qubriux-loading
                *ngIf="totalCustomersValidEmail === null"
                [size]="15"
              ></app-qubriux-loading>
              <div id="count" *ngIf="totalCustomersValidEmail !== null">
                {{ totalCustomersValidEmail }}
              </div>
            </div>
          </div>
        </div>

        <div class="box row g-0">
          <div class="col-4 box-icon-container">
            <div class="material-symbols-outlined box-icon">call</div>
          </div>
          <div class="col-8 flex-col">
            <div class="main-label-style flex-1" id="definition">
              {{
                "SHARED_PAGE.CUSTOMER_HAVING_VALID_PHONENUMBER" | i18nTranslate
              }}
            </div>
            <div class="details">
              <app-qubriux-loading
                *ngIf="totalCustomersValidPhNo === null"
                [size]="15"
              ></app-qubriux-loading>
              <div id="count" *ngIf="totalCustomersValidPhNo !== null">
                {{ totalCustomersValidPhNo }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="top-margin-standard qb-d-flex upload-row">
        <div class="each-upload">
          <div class="d-flex align-items-center">
            <label class="main-label-style">Upload Challenge Image</label>
            <span class="material-symbols-outlined remove-img" *ngIf="badgeImageUrl" [matTooltip]="'Remove image'" (click)="badgeImageUrl = null">cancel</span>
        </div>
          <div
            class="upload-coin-img"
            (click)="fileInput.click()"
            *ngIf="!badgeImageUrl && !uploading1"
          >
            <div class="margin-0"> Click here to upload your image [.png .jpg] </div>
            <span class="material-symbols-outlined"> cloud_upload </span>
          </div>
          <app-qubriux-loading
            [size]="35"
            *ngIf="uploading1"
          ></app-qubriux-loading>
          <div *ngIf="badgeImageUrl && !uploading1" class="img-plus-upload">
            <img class="uploaded-image" [src]="badgeImageUrl" />
            <div class="upload-coin-img" (click)="fileInput.click()">
              <div class="margin-0"> Click here to replace your image [.png .jpg] </div>
              <span class="material-symbols-outlined"> cloud_upload </span>
            </div>
          </div>
          <input
            type="file"
            accept=".png, .jpg"
            #fileInput
            (change)="setUploadedFile($event, 'CHALLENGE')"
            hidden="true"
          />
        </div>

        <div class="each-upload">
          <div class="d-flex align-items-center">
            <label class="main-label-style">Upload Banner Image</label>
            <span class="material-symbols-outlined remove-img" *ngIf="bannerImageUrl" [matTooltip]="'Remove image'" (click)="bannerImageUrl = null">cancel</span>
          </div>
          <div
            class="upload-coin-img"
            (click)="fileInput2.click()"
            *ngIf="!bannerImageUrl && !uploading2"
          >
            <div class="margin-0"> Click here to upload your image [.png .jpg] </div>
            <span class="material-symbols-outlined"> cloud_upload </span>
          </div>
          <app-qubriux-loading
            [size]="45"
            *ngIf="uploading2"
            class="center-loader"
          ></app-qubriux-loading>
          <div *ngIf="bannerImageUrl && !uploading2" class="img-plus-upload">
            <img class="uploaded-image" [src]="bannerImageUrl" />
            <div class="upload-coin-img" (click)="fileInput2.click()">
              <div class="margin-0"> Click here to replace your image [.png .jpg] </div>
              <span class="material-symbols-outlined"> cloud_upload </span>
            </div>
          </div>
          <input
            type="file"
            accept=".png, .jpg"
            #fileInput2
            (change)="setUploadedFile($event, 'BANNER')"
            hidden="true"
          />
        </div>
      </div>

      <app-get-time-based-challenge-details
        [status]="status"
        #timeBasedData
      ></app-get-time-based-challenge-details>

      <div
        class="qb-d-flex qb-week-class"
        [ngClass]="{ 'cursor-notallowed': status == 'ACTIVE' }"
      >
        <mat-slide-toggle
          [ngClass]="{ 'pointerevents-none': status == 'ACTIVE' }"
          color="accent"
          [(ngModel)]="needsOptIn"
        ></mat-slide-toggle>
        <span class="fs1-rem"> Customer opt in required</span>
      </div>
      <div
        class="qb-d-flex qb-fd-coloumn"
        *ngIf="needsOptIn"
        [ngClass]="{ 'cursor-notallowed': status == 'ACTIVE' }"
      >
        <div class="main-label-style">Challenge Completion Time</div>
        <mat-radio-group
          aria-labelledby="example-radio-group-label"
          class="example-radio-group"
          [(ngModel)]="timeFrameType"
          [ngClass]="{ 'pointerevents-none': status == 'ACTIVE' }"
        >
          <mat-radio-button
            *ngFor="let type of timeFrame | keyvalue"
            color="primary"
            class="example-radio-button"
            [value]="type.key"
          >
            {{ type.value }}
          </mat-radio-button>
        </mat-radio-group>
        <div class="qb-w-25" *ngIf="timeFrameType === 'CUSTOM'">
          <div class="qb-challenge-secondary">Number Of Days</div>
          <div
            class="formDiv-challenge"
            [ngClass]="{ 'pointerevents-none': status == 'ACTIVE' }"
          >
            <input
              type="number"
              class="formInput"
              maxlength="10"
              min="0"
              max="99999999"
              (keydown)="stringNumberInputKeyDown($event, 5)"
              (input)="removeErrorMsg($event)"
              [(ngModel)]="numberOfDays"
            />
          </div>
          <div class="left-align-text-err">
            <span
              style="color: var(--main-font-red); font-size: 12px"
              id="numberDaysErrorField"
            ></span>
          </div>
        </div>
      </div>

          <div [ngClass]="{ 'cursor-notallowed': status == 'ACTIVE' }">
            <div class="qb-d-flex qb-fd-coloumn qb-w-25" [ngClass]="{ 'pointerevents-none': status == 'ACTIVE' }">
              <div class="main-label-style">Participation Limit</div>
              <div class="qb-challenge-secondary">Number Of Times</div>
              <div class="formDiv-challenge pos-rel">
                <input
                  type="number"
                  class="formInput"
                  maxlength="5"
                  (keydown)="stringInputKeyDown($event, 5)"
                  (input)="removeErrorMsg($event)"
                  min="0"
                  max="99999"
                  [(ngModel)]="usageLimit"
                  #usageInp
                />
                <div class="remaining-text-left-2">
                  {{ usageInp.value.length }}/{{ usageInp.getAttribute("maxlength") }}
                </div>
              </div>
              <div class="left-align-text-err">
                <span
                  style="color: var(--main-font-red); font-size: 12px"
                  id="numberofTimeErrorField"
                ></span>
              </div>
            </div>
          </div>

          <div [ngClass]="{'cursor-notallowed': status == 'ACTIVE' }">
            <div class="qb-d-flex qb-fd-coloumn qb-w-25" [ngClass]="{ 'pointerevents-none': status == 'ACTIVE' }">
              <div class="main-label-style">Rejoining Eligibility Period</div>
              <div class="qb-challenge-secondary">Number Of Days</div>
              <div class="formDiv-challenge pos-rel">
                <input
                  type="number"
                  class="formInput"
                  maxlength="5"
                  [(ngModel)]="rejoiningDays"
                  (keydown)="stringNumberInputKeyDown($event, 5)"
                  (input)="removeErrorMsg($event)"
                  min="0"
                  max="99999"
                  #rejoiningDaysInp
                />
                <div class="remaining-text-left-2">
                  {{ rejoiningDaysInp.value.length }}/{{
                    rejoiningDaysInp.getAttribute("maxlength")
                  }}
                </div>
              </div>
              <div class="left-align-text-err">
                <span
                  style="color: var(--main-font-red); font-size: 12px"
                  id="rejoiningDateErrorField"
                ></span>
              </div>
            </div>
          </div>
      

      <!-- 
      <div class="qb-d-flex qb-fd-coloumn">
        <div class="main-label-style">Budget Details</div>
        <app-offer-budget #offerBudgetData></app-offer-budget>
      </div> -->
    </div>
  </div>
  <div class="qb-button-container-challenge-selection">
    <div class="secondary-button" (click)="selectChallengeType('exit')">
      Close
    </div>
    <div
      class="secondary-button qb-secondary-button-save-exit"
      (click)="selectChallengeType('saveandexit')"
    >
      Save and Exit
    </div>
    <div
      class="primary-button"
      (click)="selectChallengeType('create')"
      *ngIf="!isEdit"
    >
      Next
    </div>
    <div
      class="primary-button"
      (click)="selectChallengeType('create')"
      *ngIf="isEdit"
    >
      Save
    </div>
  </div>
</div>
